import CreateNewPassword from '../../components/passwordRecovery/CreateNewPassword';

import React from 'react';
import PropTypes from 'prop-types';
import { bindActionCreators} from 'redux';
import { connect } from 'react-redux';
import {
  setEmailAndToken,
  setPassword,
  setPasswordConfirm,
  createPassword,
  validatePassword } from '../../actions/createNewPasswordActions';

class CreateNewPasswordContainer extends React.Component {

  componentDidMount() {
    this.props.setEmailAndToken(this.props.params.email, this.props.params.token);
  }

  setPasswordValue = (event) => {
    this.props.setPassword(event.target.value || '');
  }

  setPasswordConfirmValue = (event) => {
    this.props.setPasswordConfirm(event.target.value || '');
  }

  render() {
    const {
      errorText,
      isCreateFetching,
      password,
      passwordConfirm
    } = this.props;

    return (
      <CreateNewPassword
        checkPasswordLength={this.props.validatePassword}
        createPassword={this.props.createPassword}
        errorText={errorText}
        isCreateFetching={isCreateFetching}
        password={password}
        passwordConfirm={passwordConfirm}
        setPassword={this.setPasswordValue}
        setPasswordConfirm={this.setPasswordConfirmValue} />
    );
  }
}

CreateNewPasswordContainer.propTypes = {
  createPassword: PropTypes.func.isRequired,
  errorText: PropTypes.string,
  isCreateFetching: PropTypes.bool.isRequired,
  params: PropTypes.object,
  password: PropTypes.string,
  passwordConfirm: PropTypes.string,
  setEmailAndToken: PropTypes.func.isRequired,
  setPassword: PropTypes.func.isRequired,
  setPasswordConfirm: PropTypes.func.isRequired,
  validatePassword: PropTypes.func.isRequired
};

function mapStateToProps(state) {
  return {
    errorText: state.createNewPassword.errorText,
    isCreateFetching: state.createNewPassword.isFetching,
    password: state.createNewPassword.password,
    passwordConfirm: state.createNewPassword.passwordConfirm
  };
}

function mapDispatchToProps(dispatch) {
  return {
    ...bindActionCreators({
      setEmailAndToken,
      createPassword,
      setPassword,
      setPasswordConfirm,
      validatePassword
    }, dispatch)
  };
}

export default connect(mapStateToProps, mapDispatchToProps)(CreateNewPasswordContainer);
